<script>
export let title;
export let className;
export let link;
</script>

<a href="{link}" class="btn {className}">{title} </a>
